import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import { version } from "../../package";
import user from "./modules/userStore";
import category from "./modules/categoryStore";
import courses from "./modules/courseStore";
import events from "./modules/eventStore";
import teacher from "./modules/teacherStore";
import cart from "./modules/cartStore";
import adminAuth from "./modules/adminAuthenticationStore";
import notifications from "./modules/notifications";

Vue.use(Vuex);
const vuexPersist = new VuexPersist({
  key: "edfore",
  storage: localStorage
});
export const store = new Vuex.Store({
  state: {
    version: ""
  },
  mutations: {
    initialiseStore(state) {
      // Check if the store exists
      if (localStorage.getItem("edfore")) {
        const edfore = JSON.parse(localStorage.getItem("edfore"));
        // Check the version stored against current. If different, don't
        // load the cached version
        const initialState = {
          user: user.state,
          category: category.state,
          courses: courses.state,
          events: events.state,
          teacher: teacher.state,
          cart: cart.state,
          adminAuth: adminAuth.state,
          notifications: notifications.state
        };
        if (edfore.version && edfore.version === version) {
          this.replaceState(Object.assign(state, edfore));
        } else {
          state.version = version;
          Object.keys(initialState).forEach(key => {
            state[key] = initialState[key];
          });
        }
      }
    }
  },
  modules: {
    user,
    category,
    courses,
    events,
    teacher,
    cart,
    adminAuth,
    notifications
  },
  plugins: [vuexPersist.plugin]
});
